<template>
    <span
        class="mr-2"
        :class="{
            'chip-emerald': status == 0,
            'chip-rose': status == 1,
            'chip-amber': status != 0 && status != 1,
        }"
    >
        {{ statusName }}
    </span>
</template>

<script>
export default {
    props: ["status"],

    computed: {
        statusName() {
            switch (this.status) {
                case 0:
                case false:
                    return "Descontado do fornecedor";
                case 1:
                case true:
                    return "Descontado do produtor";
                default:
                    return this.status;
            }
        },
    },
};
</script>
